import React from 'react';
import StatisticsPage from '../components/supplierStats/StatisticsPage';
export default function SupplierStatsSupplierBrands() {
  return <StatisticsPage kind="supplier-brands" />;
}
